import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'regexReplace', })
export class RegexReplacePipe implements PipeTransform {
  transform(value: string, searchValue: string, replaceValue: string): string {
    if (!value) return value;
    const regex = new RegExp(searchValue, 'g');
    return value.replace(regex, replaceValue);
  }
}
